<nav *ngIf="HeaderHideInPOS()" #navbar class="navbar active">
    <div class="container-fluid">
        <div class="navbar-header">
            <a href="#" onClick="return false;" class="navbar-toggle collapsed" (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
            <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
            <a class="navbar-brand" >            
                <span class="logo-name" style="margin-left: 12px;">KOA-GLOBAL</span>
            </a>
        </div>
        <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
            <ul class="pull-left collapse-menu-icon">
                <li>
                    <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
                        <mat-icon>menu</mat-icon>
                    </button>
                </li>  
            </ul>

           
            <ul class="nav navbar-nav navbar-right">
                <li class="fullscreen">
                    <h4 style="color: white;
                    margin-top: 15px;
                    padding: 2px 15px;font-size: 20px;font-weight: 400;">{{FirstName+' '+LastName}}</h4>
                </li>

                <li class="fullscreen">
                    <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons">
                        <mat-icon>fullscreen</mat-icon>
                    </button>
                </li>
           
                <li class="nav-item user_profile" ngbDropdown>
                    <a href="#" onClick="return false;" ngbDropdownToggle role="button" class="nav-notification-icons pt-0">
                        <img src="assets/images/images-favicon.ico" class="rounded-circle" width="32" height="32" alt="User">
                    </a>
                    <div ngbDropdownMenu class="notification-dropdown pullDown">
                        <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
                            <ul class="menu">
                                <li class="body">
                                    <ul class="user_dw_menu">
                                        <!-- <li>
                                            <a href="#" onClick="return false;">
                                                <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>Profile
                                            </a>
                                        </li> -->
                                        <li>
                                            <ng-template #changePswd let-modal>
                                                <form #changePasswordForm="ngForm" name="changePasswordForm">
                                                    <div class="modal-header d-block text-center">
                                                        <h2 class="modal-title " id="modal-basic-title">Change Password</h2>
                                                        <button class="close" aria-label="Close"></button>
                                                    </div>
                                                    <div class="modal-body pb-0">
                                                        <div class="row justify-content-center">
                                                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                                <div class="example-container">
                                                                    <mat-form-field class="example-full-width"
                                                                        appearance="outline">
                                                                        <mat-label>Old Password</mat-label>
                                                                        <input matInput type="number"
                                                                            [(ngModel)]="changePswdObj.OldPassword"
                                                                            name="Old Password" required>
                                                                    </mat-form-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                                <div class="example-container">
                                                                    <mat-form-field class="example-full-width"
                                                                        appearance="outline">
                                                                        <mat-label>New Password</mat-label>
                                                                        <input matInput type="number"
                                                                            [(ngModel)]="changePswdObj.NewPassword"
                                                                            name="New Password" required>
                                                                    </mat-form-field>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                                                <div class="example-container">
                                                                    <mat-form-field class="example-full-width"
                                                                        appearance="outline">
                                                                        <mat-label>Confirm Password</mat-label>
                                                                        <input matInput type="number"
                                                                            [(ngModel)]="changePswdObj.ConfirmPassword"
                                                                            name="Confirm Password" required>
                                                                    </mat-form-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pl-4">
                                                        <span style="color:red">*</span> Indicates Mandatory fields
                                                    </div>
                                                    <ul class="d-flex justify-content-center">
                                                        <li class="mx-1">
                                                            <button mat-raised-button class="btn-block" color="primary"
                                                                (click)="submitChange(changePasswordForm.form)">
                                                                Submit
                                                            </button>
                                                        </li>
                                                        <li class="mx-1">
                                                            <button mat-raised-button class="btn-block" color="warn"
                                                            (click)="closeBtnModal()">
                                                                Close
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </form>
                                            </ng-template>


                                            <a (click)="changePassword(changePswd)" class="pointer">
                                                <mat-icon aria-hidden="false" class="mr-2">vpn_key</mat-icon>Change Password
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" (click)="logout()">
                                                <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>
                                                Logout
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <!-- #END# Tasks -->
                <!-- <li class="pull-right">
          <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons js-right-sidebar">
            <mat-icon id="settingBtn">settings</mat-icon>
          </button>
        </li> -->
            </ul>
        </div>
    </div>
</nav>